module.exports = ".nav-pills .nav-link.active, .nav-pills .show > .nav-link {     \r\n    background-color:white;   \r\n    color: #2196F3;\r\n    font-weight: 600;    \r\n}\r\n\r\n.nav-pills .nav-link {    \r\n    color: black;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/psadetails/psadetails-grid/psadetails-grid.component.css
// module id = ./src/app/pages/functions/psadetails/psadetails-grid/psadetails-grid.component.css
// module chunks = main